import {apsEnums} from "../../shared/dto/aps.enums";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import * as _ from "lodash";
import {UserProfile} from "../userProfile";

export default class ChatMessage {
  userProfileData: apsViewModels.UserProfileData;

  isChat: boolean;
  isDefect: boolean;
  isToolChange: boolean;
  isDowntime: boolean;
  id: string;
  message: string;
  createdByFullName: string;
  createdOn: Date;
  type: apsEnums.ChatItemType;
  machineId: string;
  section: number;
  gobName: string;
  defectLegacyId: number;
  defectAbbr: string;
  severity: apsEnums.Severity;
  createdById: string;

  constructor(data: apsViewModels.ChatItemBase, userProfileData: apsViewModels.UserProfileData) {
    this.userProfileData = userProfileData;
    _.assign(this, data);
    switch (this.type) {
      case apsEnums.ChatItemType.Chat:
        this.isChat = true;
        break;
      case apsEnums.ChatItemType.Defect:
        this.isDefect = true;
        break;
      case apsEnums.ChatItemType.Downtime:
        this.isDowntime = true;
        break;
      case apsEnums.ChatItemType.ToolChange:
        this.isToolChange = true;
        break;
    }
  }

  private getDefectLabel() {
    return (this.userProfileData && this.userProfileData.displayDefectsByNumber)
      ? this.defectLegacyId.toString()
      : this.defectAbbr;
  }

  defectLabel(): string {
    let label = this.isDefect ? this.getDefectLabel() : '';

    return label;
  }

  location(shopConfig: apsViewModels.ShopConfigurationWithShifts): string {
    var machine: apsViewModels.MachineConfiguration;
    if (this.machineId && shopConfig) {
      machine = _.find(shopConfig.machineConfigurations, {id: this.machineId});
    } else {
      return '';
    }

    var jobRun = _.first(shopConfig.jobRuns);
    var section = this.section;
    if (machine) {
      if (section && machine.number === 2 && jobRun) {
        section = section + jobRun.numberOfSections;
      }
    } else {
      return '';
    }

    if (section) {
      if (this.gobName) {
        return section.toString() + this.gobName;
      } else {
        return section.toString();
      }
    }

    return machine.name;
  }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/models/chat/chatMessage.ts